import { Controller, useFormContext } from "react-hook-form";
import { Checkbox, CheckboxProps } from "./checkbox";

export type ControlledCheckboxProps = Omit<
  CheckboxProps,
  "onValueChange" | "isSelected"
> & {
  name: string;
};

export function ControlledCheckbox({
  name,
  ...props
}: ControlledCheckboxProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <Checkbox
            {...props}
            {...field}
            isInvalid={!!fieldState?.error?.message}
            isSelected={field.value ?? false}
            name={name}
            onValueChange={(checked) => {
              field.onChange(checked);
            }}
          />
        );
      }}
    />
  );
}
